const HomeCtrl = function () {};

export default HomeCtrl;
